import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { api } from "~/lib/api";
import { LiveProvider } from "~/lib/live";

export const Route = createFileRoute("/_authed")({
  beforeLoad: async ({ context }) => {
    try {
      await context.queryClient.ensureQueryData({
        queryKey: ["me"],
        queryFn: () => api.me(),
      });
    } catch {
      throw redirect({ to: "/login" });
    }
  },
  component: () => (
    <LiveProvider>
      <Outlet />
    </LiveProvider>
  ),
});
